// src/pages/Loads/Loads.jsx
import React, { useEffect, useState } from "react";
import FiltersPagination from "../../components/elements/FiltersPagination";
import DataTableElement from "../../components/elements/DataTableElement";
import {
  loadsResource,
  trailerTrucksResource,
  changeStatusLoad,
} from "../../helpers/configRoutes/backend_helper";
import { Columns } from "./Columns";
import CustomButton from "../../components/form/CustomButton";
import { useNavigate } from "react-router-dom";
import AddUpdLoadModal from "./AddUpdLoadModal";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";
import EvidencesFilesModal from "./EvidencesFilesModal";
import { useDispatch } from "react-redux";
import { reset_load, update_load } from "../../store/loads/action";
import LoadsMapView from "./LoadsMapView"; // 👈 nuevo componente

const Loads = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [filters, setFilters] = useState({
    endDate: "",
    startDate: "",
    search: "",
    from: 0,
    to: 0,
    page: 1,
    truck: true,
  });

  const [tableLoad, setTableLoad] = useState({
    show: false,
    textLoad: "Loading loads...",
  });
  const [meta, setMeta] = useState({ total: 0, current_page: 0 });
  const [data, setData] = useState([]);

  const [modalConfirm, setModalConfirm] = useState({
    show: false,
    title: "Delete Truck",
    loadig: false,
    textLoad: "Processing",
  });
  const [modal, setModal] = useState({ show: false });
  const [trailerTruckItem, setTrailerTruckItem] = useState({ id: null });
  const [modalFiles, setModalFiles] = useState({
    show: false,
    item: {},
    title: "Show files",
  });
  const [loadinStatus, setLoadinStatus] = useState(false);

  // 👇 nuevo: modo de vista
  const [viewMode, setViewMode] = useState("table"); // 'table' | 'map'

  useEffect(() => {
    const getData = async () => {
      setTableLoad({ ...tableLoad, show: true });
      const response = await loadsResource("get", { params: filters });
      setData(response.loads || []);
      setMeta(response.meta || { total: 0, current_page: 0 });
      setTableLoad({ ...tableLoad, show: false });
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const openModalAdd = (trailerTruckItem = {}) => {
    if (trailerTruckItem.id) {
      dispatch(update_load(trailerTruckItem));
      navigate(`/load/${trailerTruckItem.id}`);
      return true;
    }
    dispatch(reset_load());
  };

  const deleteTrailerTruck = async () => {
    setModalConfirm({ ...modalConfirm, loading: true });
    const response = await trailerTrucksResource(
      "del",
      {},
      modalConfirm.id
    );
    if (response.status) {
      setFilters({ ...filters });
    }
    setModalConfirm({
      ...modalConfirm,
      loading: false,
      show: false,
      id: null,
    });
  };

  const completeFinishLoad = async (load_id, status_id) => {
    setLoadinStatus(true);
    const response = await changeStatusLoad({
      load_id: load_id,
      status_id: status_id,
    });
    if (response.status) {
      setFilters({ ...filters });
    }
    setLoadinStatus(false);
  };

  const cols = Columns(
    openModalAdd,
    setModalConfirm,
    modalConfirm,
    modalFiles,
    setModalFiles,
    completeFinishLoad,
    loadinStatus
  );

  return (
    <div className="min-h-screen bg-cs-surface">
      <div className="px-4 md:px-6 py-6 max-w-auto mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-cs-dark">Loads</h1>
            <p className="text-sm text-cs-muted mt-1">
              Manage loads, documents and related assignments with full
              tracking.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            {/* Toggle Table / Map */}
            <div className="inline-flex items-center bg-cs-bg border border-cs-border rounded-xl text-[11px] overflow-hidden">
              <button
                type="button"
                onClick={() => setViewMode("table")}
                className={`
                  px-3 py-1.5
                  ${viewMode === "table"
                    ? "bg-cs-primary text-white"
                    : "bg-cs-bg text-cs-muted"
                  }
                  text-xs font-medium transition-colors
                `}
              >
                Table view
              </button>
              <button
                type="button"
                onClick={() => setViewMode("map")}
                className={`
                  px-3 py-1.5 border-l border-cs-border
                  ${viewMode === "map"
                    ? "bg-cs-primary text-white"
                    : "bg-cs-bg text-cs-muted"
                  }
                  text-xs font-medium transition-colors
                `}
              >
                Map view
              </button>
            </div>

            <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
              Total loads:{" "}
              <span className="font-semibold text-cs-dark">
                {meta?.total ?? data.length}
              </span>
            </div>

            <CustomButton
              onClick={() => navigate("/loads-new")}
              className="
                inline-flex items-center gap-2
                px-4 py-2.5
                rounded-xl
                bg-cs-primary hover:bg-cs-primary-hover
                text-white text-sm font-medium
                shadow-md hover:shadow-lg
                transition-all
              "
            >
              <span className="material-symbols-outlined text-sm">add</span>
              Add new load
            </CustomButton>
          </div>
        </div>

        {/* Tabla + filtros / Mapa + filtros */}
        <div
          className="
            bg-cs-bg border border-cs-border rounded-2xl
            shadow-sm px-2 py-2
          "
        >
          <FiltersPagination
            showFilters={true}
            filters={filters}
            setFilters={setFilters}
            meta={meta}
            statusModel="Load"
          >
            {viewMode === "table" ? (
              <DataTableElement
                columns={cols}
                items={data}
                tableLoad={tableLoad}
              />
            ) : (
              <LoadsMapView loads={data} loading={tableLoad.show} />
            )}
          </FiltersPagination>
        </div>

        <ConfirmDeleteModal
          modal={modalConfirm}
          setModal={setModalConfirm}
          action={deleteTrailerTruck}
        />
      </div>
    </div>
  );
};

export default Loads;
